<template>
    <div>
        <h5 class="mb-4">
            <strong>Gestión de lenguajes</strong>
        </h5>

        <b-row class="mb-3">
            <b-col md="3">
                <b-form-group label="Lenguaje">
                    <b-form-input v-model="filterLanguagesSga.name" type="text" placeholder="Buscar por nombre"
                        class="form-control" />
                </b-form-group>
            </b-col>

            <b-col md="3" class="mt-auto">
                <b-form-group>
                    <b-button variant="primary" @click="searchLanguagesSga">
                        <i class="fa fa-search"></i>
                        <span class="ml-1" v-text="'Buscar'"></span>
                    </b-button>
                    <b-button class="mx-1" @click="clearFilter">
                        <i class="fa fa-eraser"></i>
                        <span class="ml-1" v-text="'Limpiar'"></span>
                    </b-button>
                </b-form-group>
            </b-col>

            <b-col md="12" class="mt-4 d-flex justify-content-end align-items-center">
                <b-form-group>
                    <b-button variant="primary" @click="createLanguage">
                        <i class="fa fa-plus" />
                        <span class="ml-1" v-text="'Nuevo lenguaje'" />
                    </b-button>
                </b-form-group>
            </b-col>

            <b-modal id="modal_create_languages" size="md" hide-footer no-close-on-esc no-close-on-backdrop
                hide-header-close>
                <template #modal-title>
                    {{ action === 'edit' ? 'Editar' : 'Registrar nuevo' }} lenguaje
                </template>
                <formLanguages />
            </b-modal>

            <b-col md="12">
                <b-form-group>
                    <b-table :items="languagesSga.data" :fields="fields" responsive striped hover bordered
                        thead-tr-class="table-active" show-empty thead-class="table-active"
                        empty-text="No hay resultados para mostrar.">
                        <template #cell(is_active)="data">
                            <b-badge :variant="data.item.is_active ? 'success' : 'danger'"
                                v-text="data.item.is_active ? 'ACTIVO' : 'INACTIVO'" />
                        </template>
                        <template #cell(actions)="data">
                            <div class="d-flex justify-content-lg-center justify-content-between flex-wrap flex-nowrap">
                                <el-tooltip class="ml-2" :content="data.item.is_active ? 'Inactivar' : 'Activar'"
                                    placement="top" effect="light">
                                    <el-button type="text" @click="changeStatus(data.item.id)"
                                        :class="`${!data.item.is_active ? 'text-success' : 'text-danger'}`">
                                        <i :class="`fa fa-lg ${!data.item.is_active ? 'fa-check' : 'fa-close'}`"></i>
                                    </el-button>
                                </el-tooltip>
                            </div>
                        </template>
                    </b-table>
                </b-form-group>
            </b-col>

            <b-col md="12">
                <b-form-group>
                    <div class="d-flex justify-content-end align-items-center pr-4">
                        <el-pagination style="max-width: 100%" v-model="filterLanguagesSga.page"
                            :total="filterLanguagesSga.total" :current-page="filterLanguagesSga.page"
                            :page-size="filterLanguagesSga.per_page" @size-change="afterChangeSizePagination"
                            @current-change="afterChangePagePagination" :page-sizes="[10, 30, 50, 100]"
                            layout="total, sizes, prev, pager, next" />
                    </div>
                </b-form-group>
            </b-col>

        </b-row>

    </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import formLanguages from './FormLanguages.vue';
export default {
    name: 'Languages',
    components: {
        formLanguages,
    },
    data() {
        return {
            fields: [
                {
                    key: "code",
                    label: "Código",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "name",
                    label: "Lenguaje",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "is_active",
                    label: "Estado",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "user.name",
                    label: "Creado por",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "actions",
                    label: "Acciones",
                    sortable: false,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
            ],
        };
    },

    computed: {
        ...mapState('sgaLanguages', ['languagesSga', 'action', 'filterLanguagesSga']),
    },

    methods: {
        ...mapActions('sgaLanguages', ['getLanguagesSga', 'changeStatusLanguageSga', 'showLanguageSga']),
        ...mapMutations('sgaLanguages', ['setActionLanguageSga', 'setDefaultFilterSgaLanguages', 'loadAfterChangeSizePagination',
            'loadAfterChangePagePagination', 'setLanguageSga']),

        createLanguage() {
            this.setActionLanguageSga('create');
            this.$bvModal.show('modal_create_languages');
        },

        async clearFilter() {
            this.setDefaultFilterSgaLanguages();
            await this.getLanguagesSga();
        },

        async afterChangeSizePagination(size) {
            this.loadAfterChangeSizePagination(size);
            await this.getLanguagesSga();
        },

        async afterChangePagePagination(page) {
            this.loadAfterChangePagePagination(page);
            await this.getLanguagesSga();
        },

        async changeStatus(id) {
            await this.changeStatusLanguageSga(id);
            await this.getLanguagesSga();
        },

        editLanguage(language) {
            this.showLanguageSga(language.id);
            this.setActionLanguageSga('edit');
            this.$bvModal.show('modal_create_languages');
        },

        async searchLanguagesSga() {
            await this.getLanguagesSga(true);
        },
    },
};
</script>
